/**
 * ChefYoda toque logo (marketing-site nav SVG, verbatim paths). Lives
 * in shared/ so Login + AuthLoadingScreen can render it without
 * pulling the lazy OrderPad chunk into the main bundle.
 */

import { CHEFYODA_GOLD_STROKE } from '@/lib/chefyodaBrand';

export function ChefYodaToque({ size = 30 }: { size?: number }) {
  const gold = CHEFYODA_GOLD_STROKE;
  return (
    <svg width={size} height={(size * 50) / 46} viewBox="0 0 46 50" fill="none" aria-hidden>
      <path
        d="M38 42 C38 28 28 18 22 14 C16 10 10 12 8 18 C6 22 8 28 12 32 C14 34 16 36 16 40 L16 42"
        stroke={gold}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M38 42 C38 28 48 18 44 14 C40 11 34 13 32 18 C30 22 32 28 32 32 C33 35 38 37 38 42"
        stroke={gold}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <rect x="12" y="42" width="30" height="7" rx="1" fill="none" stroke={gold} strokeWidth="2" />
      <line
        x1="21"
        y1="42"
        x2="19"
        y2="20"
        stroke={gold}
        strokeWidth="1"
        strokeDasharray="2 3"
        opacity="0.7"
      />
      <line
        x1="27"
        y1="42"
        x2="27"
        y2="16"
        stroke={gold}
        strokeWidth="1"
        strokeDasharray="2 3"
        opacity="0.7"
      />
      <line
        x1="33"
        y1="42"
        x2="35"
        y2="20"
        stroke={gold}
        strokeWidth="1"
        strokeDasharray="2 3"
        opacity="0.7"
      />
      <circle cx="19" cy="26" r="1.5" fill={gold} opacity="0.9" />
      <circle cx="27" cy="22" r="1.5" fill={gold} opacity="0.9" />
      <circle cx="35" cy="26" r="1.5" fill={gold} opacity="0.9" />
    </svg>
  );
}
